<template>
  <div>
    <baseFrame
      submitText="提交"
      clearText=""
      @submit="submit"
      @cancel="handleToPlanList"
      :submitLoading="submitLoading"
      :showCtrls="true"
      :infosArr="infosArr"
      :id="receivableStocktakingPlan.code"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="盘点结果调整">
          <lk-form>
            <lk-row>
              <lk-col>
                <lk-form-item>
                  <div class="requireStocktakingAdjust">
                    <lk-table
                      border
                      :columns="columns"
                      :data="tableData">
                    </lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal
      v-model="showModal"
      :title="this.config.modalTitle"
      :width="900"
      :closable='false'
      :mask-closable='false'
      >
      <div>
        <div :gutter="16" class="queryParams mb8">
          <div v-for="(item) in config.queryList" :key="item.id">
            <span>{{`${item.title}：`}}</span>
            <lk-input v-if="item.type === 'input'" style="width:140px" v-model="queryParams[item.queryName]"></lk-input>
            <timeStampDatePicker type='daterange' v-if="item.type === 'date'" style="width:140px" v-model="queryParams[item.queryName]">
            </timeStampDatePicker>
          </div>
          <div>
            <lk-button type="primary" class="mr8" @click='getOrders'>查询</lk-button>
            <lk-button @click='clear'>重置</lk-button>
          </div>
          <span class="notesTxt" v-if="this.config.type === 1">注：请首先完成收款单的核销，再进行关联</span>
        </div>
        <lk-table class='mb8' :data='config.orderList' :columns='config.columns' border
          @on-select='addSelecttion'
          @on-select-all='addSelecttion'
          @on-select-cancel="handleTempCancel"
          @on-select-all-cancel="handleTempCancelAll"
        ></lk-table>
        <lk-page style='text-align: right'   size="small" show-elevator show-sizer :total='queryParams.count'
          @on-change='handlePageChange'
          @on-page-size-change='handleSizeChange'
        ></lk-page>
      </div>
      <div class="modalFooter" slot="footer">
        <lk-button @click='handleCancelSelection'>取消</lk-button>
        <lk-button type='primary' @click='handleSelection'>确定</lk-button>
      </div>
    </lk-modal>
    <DTPModal
      v-model="showDTPModal"
      :content="this.config.toastContent"
      @confirm="confirmDTPModal"
      @handleCancel="cancelDTPModal">
    </DTPModal>
  </div>
</template>
<script>
import baseFrame from '@/components/frame/BaseFrame.vue';
import inventoryManage from '@/services/inventoryManage';
import DTPModal from '@/components/DTPModal.vue';
import utils from '@/libs/utils';

export default {
  name: 'inventoryAdjust',
  components: {
    baseFrame,
    DTPModal,
  },
  data() {
    return {
      showDTPModal: false,
      toastContent: '',
      tempId: '', // 暂存调整的id
      tempList: [], // 暂存所选的单子
      queryParams: {
        page: 1,
        size: 10,
        count: 0,
      },
      showModal: false,
      submitLoading: false,
      receivableStocktakingPlan: {},
      infosArr: [],
      subData: [],
      config: {
        type: '', // 1关联收款单，2关联销售明细
        columns: [], // table的column
        notes: '', // 右边提示语
        queryList: {}, // 搜索
        orderList: [], // tableData
        planId: '', // 盘点单id
        goodsStoreId: '', // 首映商品id
        goodsBatchNumber: '', // 批号
        expandName: '', // expand收款单depositDetailList，销售明细orderDetailList
        detailedName: '', // 收款单financedetailID，销售明细saleorderdetailID
        modalTitle: '', // modal的title
        toastContent: '', // 弹窗提示
      },


      applyReason: '',
      adjustTotalCount: 0,
      adjustTotalPrice: 0,

      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, { row }) => h('lk-table', {
            props: {
              columns: row.diffNum > 0
                ? this.subcolumns2.filter(item => item.type !== 'selection')
                : this.subcolumns.filter(item => item.type !== 'selection'),
              data: row.diffNum > 0
                ? row.orderDetailList
                : row.depositDetailList,
            },
          }),
        },
        { title: '序号', type: 'index', width: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '通用名', key: 'approvedName', minWidth: 110 },
        { title: '商品名', key: 'goodsName', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '应收数量', key: 'receivablesNum', minWidth: 110 },
        {
          title: '实盘数量', key: 'realCount', minWidth: 130,
        },
        { title: '盘点差异', key: 'diffNum', minWidth: 110 },
        {
          title: '操作',
          // fixed: 'right',

          minWidth: 110,
          render: (h, { row }) => h('div', [
            row.diffNum > 0 && h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.tempList = row.orderDetailList;
                  this.tempId = row.id;
                  this.config.type = 2;
                  this.config.columns = this.subcolumns2.filter(item => item.type !== 'delete');
                  this.config.notes = '';
                  this.config.planId = row.planId;
                  this.config.goodsStoreId = row.goodsStoreId;
                  this.config.goodsBatchNumber = row.goodsBatchNumber;
                  this.config.detailedName = 'saleOrderDetailId';
                  this.config.modalTitle = '销售明细';
                  this.config.expandName = 'orderDetailList';
                  this.config.toastContent = '请选择正确的销售明细';
                  this.config.queryList = [
                    {
                      id: 21,
                      title: '销售单号',
                      type: 'input',
                      queryName: 'saleOrderCode',
                    },
                    {
                      id: 22,
                      title: '商品搜索',
                      type: 'input',
                      queryName: 'nameMix',
                    },
                    {
                      id: 23,
                      title: '销售日期',
                      type: 'date',
                      queryName: 'saleTimes',
                    },
                  ];
                  this.resetQuery();
                  this.showModal = true;
                  this.getOrders();
                },
              },
            }, '关联销售明细'),
            row.diffNum < 0 && h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.tempList = row.depositDetailList;
                  this.tempId = row.id;
                  this.config.type = 1;
                  this.config.columns = this.subcolumns.filter(item => item.type !== 'delete');
                  this.config.notes = '注：请首先完成收款单的核销，再进行关联';
                  this.config.planId = row.planId;
                  this.config.goodsStoreId = row.goodsStoreId;
                  this.config.goodsBatchNumber = row.goodsBatchNumber;
                  this.config.detailedName = 'financeDepositDetailId';
                  this.config.expandName = 'depositDetailList';
                  this.config.modalTitle = '收款单';
                  this.config.toastContent = '请选择正确的收款单';
                  this.config.queryList = [
                    {
                      id: 11,
                      title: '收款单号',
                      type: 'input',
                      queryName: 'financeDepositCode',
                    },
                    {
                      id: 12,
                      title: '收款日期',
                      type: 'date',
                      queryName: 'proceedsTimes',
                    },
                    {
                      id: 13,
                      title: '付款人',
                      type: 'input',
                      queryName: 'paymentUserName',
                    },
                  ];
                  this.resetQuery();
                  this.showModal = true;
                  this.getOrders();
                },
              },
            }, '关联收款单'),
          ]),
        },
      ],
      subcolumns: [ // 关联收款单column
        { type: 'selection', width: 60 },
        { title: '收款单号', key: 'financeDepositCode', width: 110 },
        { title: '核销订单号', key: 'saleOrderCode', width: 110 },
        { title: '门店名称', key: 'storeName', minWidth: 110 },
        {
          title: '收款日期',
          key: 'financeCreateTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.financeCreateTime
            ? utils.exchangeTime(row.financeCreateTime)
            : ''),
        },
        { title: '收款方式', key: 'proceedsTypeName', minWidth: 110 },
        { title: '收款金额', key: 'proceedsAmount', minWidth: 110 },
        { title: '付款人', key: 'paymentUserName', minWidth: 110 },
        { title: '联系方式', key: 'paymentUserPhone', minWidth: 110 },
        { title: '预收核销金额', key: 'verificationAmount', minWidth: 110 },
        { title: '创建人', key: 'createUserName', minWidth: 110 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.createTime
            ? utils.exchangeTime(row.createTime)
            : ''),
        },
        {
          title: '操作',
          // fixed: 'right',
          type: 'delete',
          minWidth: 110,
          render: (h, { row, index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.deleteDetail(row.id, index);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      subcolumns2: [ // 关联销售明细column
        { type: 'selection', width: 60 },
        { title: '销售单号', key: 'saleOrderCode', width: 110 },
        { title: '门店名称', key: 'storeName', minWidth: 110 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          render: (h, { row }) => h('span', row.createTime
            ? utils.exchangeTime(row.createTime)
            : ''),
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedName', minWidth: 110 },
        { title: '行号', key: 'lineNum', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批次', key: 'goodsBatchSeq', minWidth: 110 },
        { title: '数量', key: 'verificationCount', minWidth: 110 },
        {
          title: '操作',
          // fixed: 'right',
          type: 'delete',
          minWidth: 110,
          render: (h, { row, index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.deleteDetail(row.id, index);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    tempListIdArr() {
      return this.tempList.map(item => item[this.config.detailedName]);
    },
  },
  methods: {
    deleteDetail(id, index) {
      this.tableData.forEach((item) => {
        if (item.parentId === id) {
          item[this.config.expandName].splice(index, 1);
        }
      });
    },
    confirmDTPModal() {
      this.showDTPModal = false;
    },
    cancelDTPModal() {
      this.showDTPModal = false;
    },
    handleTempCancelAll() {
      this.tempList = this.findAdjustList(this.config.type, this.tempId);
    },
    handlePageChange(page) {
      this.queryParams.page = page;
      this.getOrders();
    },
    handleSizeChange(size) {
      this.queryParams.size = size;
      this.getOrders();
    },
    addSelecttion(selection) {
      const newSelection = selection.filter(item => !this.tempListIdArr.includes(item[this.config.detailedName]));
      this.tempList = this.tempList.concat(newSelection);
    },
    handleCancelSelection() {
      this.tempList = this.findAdjustList(this.tempId);
      this.showModal = false;
    },
    findAdjustList(id) {
      const list = this.tableData.find(item => item.id === id);
      if (list) {
        return list[this.config.expandName];
      }
      return [];
    },
    handleSelection() {
      // 选择的明细的可核销的数量判断不能大于盘点单的核销数量
      let receivablesNum = 0;
      if (this.tempList.length) {
        receivablesNum = this.tempList.reduce((pre, item) => pre + item.verificationCount || 0, 0);
      }
      this.tableData.forEach((item) => {
        if (item.id === this.tempId) {
          if (Math.abs(item.diffNum) >= receivablesNum) {
            this.tempList.length && this.tempList.forEach((tempItem) => {
              tempItem.parentId = this.tempId; // 明细中加上调整单的id，删除明细时使用
            });
            item[this.config.expandName] = this.tempList;
            this.showModal = false;
          } else {
            this.showDTPModal = true;
          }
        }
      });
    },
    clear() {
      this.queryParams = {
        page: 1,
        size: 10,
        count: this.queryParams.count,
      };
    },
    resetQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        count: 0,
      };
    },
    handleTempCancel(row) {
      const tempListIdx = this.tempListIdArr.indexOf(row[this.config.detailedName]);
      if (tempListIdx) {
        this.tempList.splice(tempListIdx, 1);
      }
    },
    getOrders() {
      let getOrder;
      const params = {
        ...this.queryParams,
        goodsBatchNumber: this.config.goodsBatchNumber,
        planId: this.config.planId,
        goodsStoreId: this.config.goodsStoreId,
      };
      if (this.config.type === 1) {
        getOrder = inventoryManage.getAdjustDepositList;
      } else {
        getOrder = inventoryManage.getAdjustSaleOrderList;
      }
      this.config.orderList = [];
      getOrder(params).then((res) => {
        if (res.data.status === 200) {
          this.queryParams.count = res.data.data.count;
          this.config.orderList = res.data.data.list.map((item) => {
            item._checked = this.tempListIdArr.includes(item[this.config.detailedName]);
            item._disabled = item._checked;
            return item;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = {
        id: Number.parseInt(this.$route.params.id, 10),
      };
      inventoryManage.getReceivableAdjustInfo(params)
        .then((res) => {
          if (res.data.status === 200) {
            const result = res.data.data;
            this.receivableStocktakingPlan = result.receivableStocktakingPlan || {};
            result.receivableStocktakingDetailList.length && result.receivableStocktakingDetailList.forEach((item) => {
              this.$set(item, 'depositDetailList', []);
              this.$set(item, 'orderDetailList', []);
            });
            this.infosArr = utils.setInfoArr(this.receivableStocktakingPlan);
            this.tableData = result.receivableStocktakingDetailList;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    submit() {
      let errorMsg = '';
      const invalidList = [];
      const len = this.tableData.length;
      for (let i = 0; i < len; i++) {
        const item = this.tableData[i];
        let receivablesNum = 0;
        if (item.orderDetailList && item.orderDetailList.length) {
          receivablesNum = item.orderDetailList.reduce((pre, current) => pre + current.verificationCount || 0, 0);
        } else {
          receivablesNum = item.depositDetailList.reduce((pre, current) => pre + current.verificationCount || 0, 0);
        }
        if (receivablesNum !== Math.abs(item.diffNum)) {
          errorMsg = '盘点差异未处理，请先通过补录收款单或销售订单调整应收差异，关联完毕后重新提交';
          invalidList.push((i + 1));
          break;
        }
      }
      if (errorMsg) {
        this.$Message.error(`${errorMsg}`);
        return;
      }
      const list = [];
      this.tableData.forEach((item) => {
        const {
          id, diffNum, depositDetailList, orderDetailList,
        } = item;
        list.push({
          id,
          diffNum,
          depositDetailList,
          orderDetailList,
        });
      });
      const params = {
        receivableStocktakingPlan: {
          id: this.receivableStocktakingPlan.id,
          status: this.receivableStocktakingPlan.status,
        },
        receivableStocktakingDetailList: list,
      };
      this.submitLoading = true;
      inventoryManage.submitReceivableAdjust(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.handleToPlanList();
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitLoading = false;
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    handleToPlanList() {
      this.$router.push({
        name: 'receivableList',
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.queryParams{
  display:flex;
  flex-shrink: 1;
  >div{
    width: 300px;
    display:flex;
    align-items: center;
    margin-right: 10px;
  }
}
/deep/ .ivu-modal-content {
  .notesTxt {
    color: rgb(238, 15, 52);
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>
